__webpack_require__.p = "https://ded-ps-prod.t-static.ru/projects/invest24/prod/4e6203c7b72c7e0eb5d914d2c4ddb4a0f6c03b71/_next/";